import { Sort } from '@angular/material/sort';
import { Action } from '@ngrx/store';
import { DefaultViewFilterSto } from '../../../shared/models/default-view-filter.model';
import { RelatedWorkshopSto, ServiceVanMasterDataSto } from '../models/servicevan.model.sto';

//-------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------
export const REHYDRATE = '[ServiceVan] Rehydrate';
export const DEHYDRATE = '[ServiceVan] Dehydrate';

export class RehydrateServiceVans implements Action {
  readonly type = REHYDRATE;
}

export class DehydrateServiceVans implements Action {
  readonly type = DEHYDRATE;
}

//-------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------
//export const LOAD                   = '[ServiceVan] Load service vans'
export const LOAD_SUCCESS = '[ServiceVan] Load service vans successful';
export const LOAD_FAILURE = '[ServiceVan] Load service vans failed';
export const LOAD_STOPPED = '[ServiceVan] Load service vans stopped. Store data already existing.';

export class LoadServiceVansSuccessful implements Action {
  readonly type = LOAD_SUCCESS;
}

export class LoadServiceVansFailed implements Action {
  readonly type = LOAD_FAILURE;
}

export class LoadServiceVansStopped implements Action {
  readonly type = LOAD_STOPPED;
  constructor(public viewId: string) {}
}

//-------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------
export const LOAD_PAGE = '[ServiceVan] Load service vans page';
export const LOAD_PAGE_SUCCESS = '[ServiceVan] Load service vans page successful';
export const LOAD_PAGE_FAILURE = '[ServiceVan] Load service vans page failed';

export class LoadServiceVansPage implements Action {
  readonly type = LOAD_PAGE;
  constructor(
    public payload: {
      viewId: string;
      viewFilter: DefaultViewFilterSto;
      sort: Sort | null;
      offset: number;
      force: boolean;
    }
  ) {}
}

export class LoadServiceVansPageSuccessful implements Action {
  readonly type = LOAD_PAGE_SUCCESS;
  constructor(
    public payload: {
      viewId: string;
      serviceVans: ServiceVanMasterDataSto[];
      serviceVansTotalCount: number;
      workshops?: RelatedWorkshopSto[];
      viewFilter: DefaultViewFilterSto;
      offset: number;
    }
  ) {}
}

export class LoadServiceVansPageFailed implements Action {
  readonly type = LOAD_PAGE_FAILURE;
  constructor(public payload: { viewId: string }) {}
}

//-------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------
export const LOAD_DETAILS = '[ServiceVan] Load service van details';
export const LOAD_DETAILS_SUCCESS = '[ServiceVan] Load service van details successful';
export const LOAD_DETAILS_FAILURE = '[ServiceVan] Load service van details failed';
export const LOAD_DETAILS_STOPPED = '[ServiceVan] Load service van details stopped';

export interface LoadServiceVanDetailsPayload {
  aggregateId: string;
  forceLoad?: boolean;
}

export class LoadServiceVanDetails implements Action {
  readonly type = LOAD_DETAILS;
  constructor(public payload: LoadServiceVanDetailsPayload) {}
}

export class LoadServiceVanDetailsSuccessful implements Action {
  readonly type = LOAD_DETAILS_SUCCESS;
  constructor(
    public payload: {
      request: LoadServiceVanDetailsPayload;
      response: ServiceVanMasterDataSto;
      related?: RelatedWorkshopSto[];
    }
  ) {}
}

export class LoadServiceVanDetailsFailed implements Action {
  readonly type = LOAD_DETAILS_FAILURE;
  constructor(
    public payload: {
      request: LoadServiceVanDetailsPayload;
      error: any;
    }
  ) {}
}

export class LoadServiceVanDetailsStopped implements Action {
  readonly type = LOAD_DETAILS_STOPPED;
  constructor(public payload: { request: LoadServiceVanDetailsPayload }) {}
}

export type Actions =
  | LoadServiceVansSuccessful
  | LoadServiceVansFailed
  | LoadServiceVansStopped
  | LoadServiceVansPage
  | LoadServiceVansPageSuccessful
  | LoadServiceVansPageFailed
  | LoadServiceVanDetails
  | LoadServiceVanDetailsSuccessful
  | LoadServiceVanDetailsFailed
  | LoadServiceVanDetailsStopped;
